module.exports = __webpack_public_path__ + "static/media/UST_Rose.b01569f0.png";